import Blue from "~/core";
import { retach, toggle as Toggle } from "../plugins";
import { addEvents, screen } from "../utils";
import { has } from "lodash-es";

new Blue({
  name: "Header Nav Menu",
  selector: ".header",
  setup(header) {
    const drawerToggle = header.querySelector(".header__toggle");
    const drawer = header.querySelector(".header__drawer-inner");
    const navItems = [...header.querySelectorAll(".header__nav-item")];
    const contact = header.querySelector(".header__contact");
    const media = screen.md_dn;
    const togglers = [];
    const headerHeight = header.offsetHeight;
    let lastKnownScrollPosition = 0;
    let ticking = false;

    const toggleMenu = (_, toggler) =>
      togglers.forEach((t) => {
        if (t === toggler) t.toggle();
        else t.close();
      });

    const toggleDrawer = () => {
      header.classList.toggle("is-open");
    };

    const stickyTop = () => {
      lastKnownScrollPosition = window.scrollY;
      let isHome = header.classList.contains("header--home");
      if (!ticking) {
        window.requestAnimationFrame(() => {
          let isSticky = header.classList.contains("header--sticky");
          if (lastKnownScrollPosition > headerHeight && isHome) {
            header.classList.toggle("header--home");
            header.classList.add("header--sticky");
          } else if (lastKnownScrollPosition == 0 && isSticky) {
            header.classList.toggle("header--home");
            header.classList.remove("header--sticky");
          }
          ticking = false;
        });
      }
      ticking = true;
    };

    navItems.forEach((item) => {
      const container = item;
      const trigger = item.querySelector(".header__nav-label");
      const content = item.querySelector(".header__nav-menu");
      const props = ["height", "visibility", "opacity"];

      if (!content || !trigger) return;
      const toggler = new Toggle({
        container,
        trigger,
        content,
        props,
        externalEvents: true,
      });
      togglers.push(toggler);

      addEvents(item, "click.stop", (e) => {
        if (e.target.closest(".header__nav-menu")) return;
        toggleMenu(null, toggler);
      });
    });

    retach(navItems, {
      destination: drawer,
      mediaQuery: 768,
    });

    retach(contact, {
      destination: drawer,
      mediaQuery: 768,
    });

    addEvents(drawerToggle, "click", toggleDrawer);
    addEvents(window, "click", toggleMenu);
    addEvents(window, "scroll", stickyTop);
  },
});
